<template>
  <div>
    <!--<h1>Edit {{ item && item['@id'] }}</h1>-->
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<div v-if="created" class="alert alert-success" role="status">{{ created.title }} {{$t('notifications.created')}}.</div>-->
        <!--<div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>-->
        <!--<div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>-->
        <!--<div v-if="error" class="alert alert-danger" role="alert">-->
          <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
        <!--</div>-->
        <!--<div v-if="deleteError" class="alert alert-danger" role="alert">-->
          <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}-->
        <!--</div>-->
      <!--</b-col>-->
    <!--</b-row>-->
    <b-row>
      <b-col v-if="isLoading">
        <Loader size="md"></Loader>
      </b-col>
      <b-col v-else>
        <EXCMAgreementSlaForm
                v-if="item"
                :type="2"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </b-col>
    </b-row>
    <!--<b-row>-->
      <!--<b-col>-->
        <!--<router-link-->
                <!--v-if="item"-->
                <!--:to="{ name: 'EXCMAgreementSlaList' }"-->
                <!--class="btn btn-default">Back to list</router-link>-->
        <!--<button-->
                <!--class="btn btn-danger"-->
                <!--@click="del">Delete</button>-->
      <!--</b-col>-->
    <!--</b-row>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMAgreementSlaForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMAgreementSlaForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  props: {
    agreementSlaId: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmagreementsla/update/isLoading',
      error: 'excmagreementsla/update/error',
      deleteError: 'excmagreementsla/del/error',
      deleteLoading: 'excmagreementsla/del/isLoading',
      created: 'excmagreementsla/create/created',
      deleted: 'excmagreementsla/del/deleted',
      retrieved: 'excmagreementsla/update/retrieved',
      updated: 'excmagreementsla/update/updated',
      violations: 'excmagreementsla/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMAgreementSlaList' })
    },
    updated: function (updated) {
      if (this.routeName === 'EXCMAgreementShow') {
        this.$Swal({
          title: this.$t('notifications.updated'),
          type: 'success'
        })
        this.$store.state.modals.excmagreementsla.update.updated = 1
        this.$store.state.modals.excmagreementsla.update.close = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.agreementSlaId) {
      this.retrieve(decodeURIComponent(this.agreementSlaId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'excmagreementsla/create/reset',
      deleteItem: 'excmagreementsla/del/del',
      delReset: 'excmagreementsla/del/reset',
      retrieve: 'excmagreementsla/update/retrieve',
      updateReset: 'excmagreementsla/update/reset',
      update: 'excmagreementsla/update/update',
      updateRetrieved: 'excmagreementsla/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmagreementsla ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
